import styled, { css } from 'styled-components';

import { DrawerBody, DrawerHeader, DrawerTitle } from '@components/Drawer/next';

import ResponsiveDrawer from './ResponsiveDrawer';

export const StyledResponsiveListingFilter = styled.div`
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  width: auto;
`;

export const ResponsiveListingFilterButtonLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.palette.darkGray};
  margin-left: 5px;
`;

export const StyledFilterDrawer = styled(ResponsiveDrawer)`
  ${DrawerBody} {
    padding: 0;
    background-color: ${({ theme }) => theme.palette.lynxWhite};
    overflow-x: hidden !important;
  }

  ${DrawerHeader} {
    height: 64px;
    display: flex;
    align-items: center;
  }

  ${DrawerTitle} {
    width: fit-content;
    margin: 0 auto;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    color: ${({ theme }) => theme.palette.NL800};
  }
`;

export const CollapseHeaderContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 5px;
  margin-bottom: 5px;
`;

export const CollapseHeaderLabel = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.NL800};
`;

export const ResponsiveSortTabs = styled.div`
  padding: 0;
  .rc-tabs-nav-list {
    flex-direction: column;
  }

  .rc-tabs-ink-bar-animated {
    display: none;
  }

  .rc-tabs-nav::before {
    border-bottom: none !important;
  }

  .rc-tabs-tab {
    padding: 0;
    margin-bottom: 20px;
    font-size: 16px;
    width: 100vh;
  }

  .rc-tabs-nav-list:last-child {
    margin-bottom: -20px !important;
  }
  .rc-tabs-tab + .rc-tabs-tab {
    margin-left: 0;
  }

  .rc-tabs-tab.rc-tabs-tab-active .rc-tabs-tab-btn {
    color: ${({ theme }) => theme.palette.coral};
    font-weight: bold;
    font-size: 16px;
  }

  .rc-tabs-nav {
    margin-bottom: 0;
  }
`;

export const FilterAndSortContentWrapper = styled.div`
  height: auto;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 60px;
  gap: 0px 0px;
  max-width: 100vw;
  padding: 0 8px;

  & > div {
    max-width: 100vw;
  }
`;
export const FilterAndSortWrapper = styled.div`
  grid-row: 1/2;
  overflow: auto;
`;

export const FilterAndSortApplyDiv = styled.div`
  grid-row: 2/3;
  padding: 15px;
`;

export const StyledResponsiveFilterCollapse = styled.div<{
  withMargin?: boolean;
}>`
  ${({ withMargin }) =>
    withMargin &&
    css`
      & > * {
        margin-bottom: 12px;
      }
    `}
`;

export const StyledResponsiveRegions = styled.div`
  & > div {
    max-height: 250px;
    overflow: auto;
    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      background-color: ${({ theme }) => theme.palette.lynxWhite};
      padding: 10px 15px 2px;
    }
  }

  .listing-filter-region-title {
    font-size: 16px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    .responsive-region-wrapper {
      background-color: ${({ theme }) => theme.palette.lynxWhite};
    }
  }
`;

export const StyledResponsiveHotelClassFilter = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
`;

export const StyledResponsiveHotelNameFilter = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  border-radius: 8px;
`;

export const StyledResponsiveSingleSelectionFilterContainer = styled.div`
  padding: 0 0 12px 0;
`;

export const StyledResponsiveSingleSelectionFilterItemContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  padding: 8px;
  height: 48px;
  display: flex;
  align-items: center;
  border-radius: 8px;

  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
`;

export const NonCollapsableFilterContainer = styled.div`
  width: 100%;
  height: 54px;
  padding: 15px 13px 15px 15px;
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  justify-content: space-between;
`;

export const NonCollapsableFilterLeftItems = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.brownishGrey};
  display: flex;
  align-items: flex-start;
`;

export const NonCollapsableFilterRightItems = styled.div`
  margin-top: 3px;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.eclipse};
  display: flex;
  align-items: flex-start;
`;

export const NonCollapsableFilterLeftText = styled.div`
  margin-left: 5px;
`;

export const NonCollapsableFilterRightText = styled.div`
  margin-right: 5px;
`;
export const FlightButtonWrapper = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  border: none;
  background-color: ${({ theme }) => theme.palette.B50};
  width: 102px;
  height: 32px;
  border-radius: 8px;
  margin-top: 10px;
`;
export const FilterWrapper = styled.div`
  width: 100%;
  justify-content: end;
  display: flex;
  padding-right: 8px;
`;
export const ButtonWrapper = styled.button`
  display: flex;
  padding: 2px;
  align-items: flex-start;
  gap: 2px;
  text-decoration-line: underline;
  border: none;
  background-color: transparent;
`;
